import Backbone from 'backbone'
import template from './file-format.hbs'
import BoxOptions from 'scoreboard/components/box-options'
import fileFormatOption from './file-format-option.hbs'

const FileFormat = Backbone.View.extend({

	className: 'file-format',

	initialize(options = {}) {
		this.options = options
	},

	render() {
		this.$el.append(template(this.options))
		this.options = new BoxOptions({
			template: fileFormatOption,
			availableOptions: [{
				label: 'scorecards.exportValues.step2.columns',
				subLabel: 'scorecards.exportValues.step2.columns.reason',
				icon: 'columns',
				value: 'columns',
				selected: true
			},{
				label: 'scorecards.exportValues.step2.rows',
				subLabel: 'scorecards.exportValues.step2.rows.reason',
				icon: 'rows',
				value: 'rows'
			}]
		})

		this.$('.box-options').replaceWith(this.options.el)
		this.options.render()

		this.options.on('select', option => this.trigger('select', option))

		return this
	},

	val() {
		return this.options.val()
	}
})

export default FileFormat

FileFormat.__filename__ = 'imports/file-format.js'
